/*
 * ConnectionManager Messages
 *
 * This contains all the text for the ConnectionManager.
 */
import { defineMessages } from 'react-intl';

const scope = 'connection';

export default defineMessages({
  defaultError: {
    id: `${scope}.error.default`,
    defaultMessage: 'An unknown error occurred',
  },
  credentialsError: {
    id: `${scope}.error.credentials`,
    defaultMessage: 'Invalid email or password',
  },
  connectionError: {
    id: `${scope}.error.connection`,
    defaultMessage: 'Couldn\'t connect to the server',
  },
});
